export default __webpack_public_path__ + "static/media/Soul of Atali.13188162.jpg";